import { Component, Input } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { randomString } from 'src/app/lib/random-string';
import { GallerySettingsItem } from '../../types/gallery-settings-item.type';
import { SettingsBoxComponent } from '../../../account-gallery-shared/components/settings-box/settings-box.component';

@Component({
    selector: 'app-gallery-settings-item',
    templateUrl: './gallery-settings-item.component.html',
    styleUrls: ['./gallery-settings-item.component.scss'],
    standalone: true,
    imports: [SettingsBoxComponent],
})
export class GallerySettingsItemComponent {
  @Input() item: GallerySettingsItem;
  @Input() gallery: GalleryDto;
  @Input() first: boolean;
  @Input() last: boolean;
  id = randomString(12);
}
